import { ApiService } from '@/common/api.service';

const state = {
  errors: null,
  user: {},
  isAuthenticated: undefined,
  twoFA: false,
};
const getters = {
  authErrors: (state) => state.errors,
  currentUser: (state) => state.user,
  isAuthenticated: (state) => state.isAuthenticated,
  twoFA: (state) => state.twoFA,
};

const actions = {
  checkAuth(context) {
    return new Promise((res) => {
      context.commit('purgeError');
      ApiService.get('/auth/validation')
        .then((response) => {
          if (response.data.user) {
            context.commit('setAuth', response.data);
          } else {
            context.dispatch('logout');
          }
          res();
        })
        .catch(() => {
          context.dispatch('logout');
          res();
        });
    });
  },
  login(context, user) {
    return new Promise((res, rej) => {
      ApiService.post('/auth/login', user)
        .then((response) => {
          context.commit('setAuth', response.data);
          context.commit('selectCompany', response.data.user.company);
          res(response);
        })
        .catch((err) => {
          rej(err);
        });
    });
  },
  logout(context) {
    return new Promise((res, rej) => {
      ApiService.post('/auth/logout')
        .then((response) => {
          context.commit('purgeAuth');
          res(response);
        })
        .catch((err) => {
          rej(err);
        });
    });
  },
};

const mutations = {
  setAuth(state, data) {
    state.user = data.user;
    state.twoFA = data['2fa'];
    state.isAuthenticated = true;
    state.errors = null;
  },
  purgeAuth(state) {
    state.user = {};
    state.isAuthenticated = false;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
